





































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

@Component({
  components: {},
})
export default class Bottombar extends Vue {
  public $refs!: {
    table: any,
  };

  @Action('catchments/selectLayer') private selectLayer!: any;
  @Action('catchments/getStatistics') private getStatistics!: any;
  @Action('catchments/createReport') private createReport!: any;
  @Action('catchments/deleteCatchment') private deleteCatchment!: any;
  // @Action('hospitals/setVisibility') private setHospitalsVisibility!: any;
  // @Action('doctors/setHauptfach') private setHauptfach!: any;
  // @Action('pharmacies/setVisibility') private setPharmaciesVisibility!: any;
  @Getter('catchments/layers') private catchments!: any;
  @Getter('catchments/activeLayerName') private activeLayerName!: any;
  @Getter('auth/anonymous') private anonymous!: boolean;
  // @Getter('doctors/visibility') private doctorsVisibility!: any;
  // @Getter('doctors/hauptfach') private doctorsHauptfach!: any;
  // @Getter('hospitals/visibility') private hospitalsVisibility!: any;
  // @Getter('pharmacies/visibility') private pharmaciesVisibility!: any;
  // @Getter('catchments/visibility') private catchmentsVisibility!: any;

  private pagination: any = {};
  private headers: any = [
    {
      text: 'Name',
      align: 'left',
      sortable: true,
      value: 'props.name',
    },
    {
      text: 'Limits',
      align: 'right',
      sortable: true,
      value: 'props.limits',
    },
    {
      text: 'Einheit',
      align: 'right',
      sortable: true,
      value: 'props.unit',
    },
    {
      text: '',
      align: 'right',
      sortable: false,
      value: '',
    },
    {
      text: '',
      align: 'right',
      sortable: false,
      value: '',
    },
  ];


  @Watch('catchments')
  private catchmentsChanged() {
    // short delay till everything has been drawn and etc:
    setTimeout(() => {
      if (!this.$refs.table || !this.activeLayerName || this.activeLayerName === '') {
        return;
      }
      let found = false;
      // check if it even exists
      this.$refs.table.items.forEach((el: any) => {
        if (el.props.name === this.activeLayerName) {
          found = true;
        }
      });

      if (!found) {
        return;
      }
      found = false;

      this.pagination.page = 0;

      while (!found && (this.pagination.page - 1) * this.pagination.rowsPerPage < this.pagination.totalItems) {
        this.$refs.table.filteredItems.forEach((el: any) => {
          if (el.props.name === this.activeLayerName) {
            found = true;
          }
        });
        if (!found) {
          this.pagination.page += 1;
        }
      }
    }, 500);
  }
}
